/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { globalServices } from "../../../Services/global.service";
import { storeService } from "../../../Services/store.service";
import { reportService } from "../../../Services/report.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../../Contexts/AuthContext";
import { useForm, Controller } from "react-hook-form";
import Tooltip from "../../../Components/Common/Tooltip";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import moment from "moment";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { invoicePaymentMethodServices } from "../../../Services/PDFservice/invoicepaymentmethod.service";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
import { dateFormatter } from "../../../Helpers/DateHelper";
import XLSX from "xlsx";

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    selectedLanguageId,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();

  const { userId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [posTag, setPosTag] = useState([]);
  const [pdfData, setPdfData] = useState({
    client: null,
    device: null,
    store: null,
    from: null,
    to: null,
  });

  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    posId: 0,
    from: null,
    to: null,
    pageIndex: 0,
    pageSize: 10,
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  useEffect(() => {
    updateLocName("invoices-payment-method");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getPos = (store) => {
    storeService
      .getPosByStoreId(store)
      .then((res) => {
        setPosTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleToSearch = (event) => {
    console.log("ee", event);
    setPdfData({
      client: event.tenantId.label,
      device: event.posTag.value,
      store: event.storeTag.label,
      from: event.from,
      to: event.to,
    });

    setIsLoading(true);
    reportService
      .invoicesMonth(search)
      .then((res) => {
        setReports([
          ...res.data.data,
          {
            paymentMethodName: translator("InvoiceConclusionDetail-Total"),
            totalPaidValue: res.data.data.reduce((a, b) => {
              return Number(a) + Number(b.totalPaidValue);
            }, 0),
          },
        ]);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell) {
    console.log("search", search);
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(search?.to),
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "paymentMethodName",
      text: translator("InvCashBalance-PayMethod"),
      headerStyle: () => {
        if (isMobile) return { width: "150px", textAlign: "left" };
      },
      style: () => {
        if (isMobile) return { width: "150px", textAlign: "left" };
      },
    },
    {
      dataField: "totalPaidValue",
      text: translator("InvCashBalance-TotalPaidValue"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "50%", textAlign: "right" };
      },
      style: () => {
        return { width: "50%", textAlign: "right" };
      },
    },
  ];

  const exportFunction = () => {
    invoicePaymentMethodServices.handlePrint(reports, pdfData, translator);
  };

  const exportExcelFunction = () => {
    // File name
    var ws_name = "Rekapitulacija placanja.xlsx";
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
      [
        "Period",
        `${new Intl.DateTimeFormat("hr", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }).format(pdfData.from)} - ${new Intl.DateTimeFormat("hr", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }).format(pdfData.to)}`,
      ],
      [],
      [
        translator("InvoiceCashBalancePDF-PayMethod"),
        translator("InvCashBalance-TotalPaidValue"),
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = reports.map((x) => {
      const array = [x.paymentMethodName, x.totalPaidValue];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [{ width: 20 }, { width: 20 }];
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(wb, ws_name);
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("invoices-payment-method")}</span>
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label htmlFor="ddlTenants">
                  {translator("InvIssReport-Filters-Tenants")}
                </label>

                <Controller
                  as={AsyncSelect}
                  control={control}
                  autoComplete="off"
                  name="tenantId"
                  placeholder={translator("Select-Tenant")}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === 0 ? false : true;
                    },
                  }}
                  onChange={function (event) {
                    setValue("storeTag", null);
                    setValue("posTag", null);
                    setTenantObj({
                      id: event[0].id,
                      label: event[0].label,
                      value: event[0].value,
                    });
                    setSearch({
                      ...search,
                      tenantId: event[0].id,
                    });
                    getStores(event[0].id);
                    return event[0];
                  }}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  value={tenantObj}
                />
                {errors.tenantId && errors.tenantId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label>{translator("InvIssReport-Filters-StoreTag")}</label>
                <Tooltip text={translator("StoreTagTooltip-Msg")} />
                <Controller
                  as={Select}
                  control={control}
                  autoComplete="off"
                  name="storeTag"
                  placeholder={translator("SelectStoreTag")}
                  rules={{ required: true }}
                  onChange={function (event) {
                    setValue("posTag", null);
                    getPos(event[0].id);
                    console.log("e", event[0]);
                    return event[0];
                  }}
                  options={
                    storesTag &&
                    storesTag.map((e) => ({
                      id: e.id,
                      label: e.tag,
                      value: e.name,
                    }))
                  }
                />
                {errors.storeTag && errors.storeTag.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label>{translator("InvIssReport-Filters-PosTag")}</label>{" "}
                <Tooltip text={translator("PosTagTooltip-Msg")} />
                <Controller
                  as={Select}
                  control={control}
                  autoComplete="off"
                  placeholder={translator("SelectStoreTag")}
                  name="posTag"
                  rules={{ required: true }}
                  onChange={function (event) {
                    setSearch({
                      ...search,
                      posId: Number(event[0].id),
                    });

                    return event[0];
                  }}
                  options={
                    posTag &&
                    posTag.map((e) => ({
                      id: e.posid,
                      label: e.tag + " - ( " + e.inventoryNumber + " )",
                      value: e.tag,
                    }))
                  }
                />
                {errors.posTag && errors.posTag.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12"></div>
              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label>{translator("InitialState-DateFrom")}</label>
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    maxDate={search && search.to && new Date(search.to)}
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    showYearDropdown={true}
                    name="from"
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    rules={{ required: true }}
                    valueName="selected"
                    onChange={function ([selected]) {
                      var m = moment();
                      var date = moment(selected);
                      m.set(date.toObject());
                      setSearch({
                        ...search,
                        from: date,
                      });

                      return selected;
                    }}
                  />
                </div>
                {errors.from && errors.from.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label>{translator("InitialState-DateTo")}</label>
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    minDate={search && search.from && new Date(search.from)}
                    maxDate={
                      search &&
                      search.from &&
                      new Date(new Date(search.from).getFullYear(), 11, 31)
                    }
                    disabled={!search.from}
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    showYearDropdown={true}
                    name="to"
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    rules={{ required: true }}
                    valueName="selected"
                    onChange={function ([selected]) {
                      var m = moment();
                      var date = moment(selected);
                      m.set(date.toObject());
                      setSearch({
                        ...search,
                        to: date,
                      });

                      return selected;
                    }}
                  />
                </div>
                {errors.to && errors.to.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label>{""}</label>
                <div className="form-group">
                  <button
                    className="btn btn-primary pull-left mt-2"
                    type="submit"
                  >
                    <span className="icon icon-search"></span>{" "}
                    {translator("InvIssReport-Btn-Search")}
                  </button>
                </div>
              </div>
            </form>
          </fieldset>
          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              // onTableChange={handleTableChange}
            />
          )}

          {reports.length > 1 ? (
            <>
              <button
                className="btn btn-outline-secondary"
                onClick={exportFunction}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {"  "}
              <button
                className="btn btn-outline-secondary"
                onClick={exportExcelFunction}
              >
                <i className="fas fa-file-alt"></i>{" "}
                {translator("Reports-PrintExclBtn")}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
